import { CompanyRoleDTO } from '@vyce/core/src/api/types';

// What each role is for, in a sentence or two. The role menu used to list every
// permission a role grants, which nobody read. Keyed on module_system_name, then the
// role name in lower case.
const ROLE_DESCRIPTIONS: Record<string, Record<string, string>> = {
  time: {
    admin:
      'Full control of Time. Set up and delete locations, change Time settings, and approve or amend any time log.',
    manager:
      "Runs attendance day to day. Approves and amends time logs and manages workers on sites, but can't create or delete locations or change settings.",
    supervisor:
      "On-site oversight. Sees who's clocked in, clocks workers in and out, and manages who's on a location, but can't approve or amend time logs.",
  },
  teams: {
    admin:
      'Full control of teams. Create, edit and delete teams, and manage members, qualifications and worker documents.',
    manager:
      "Runs existing teams. Adds and removes members and invites workers, but can't create, edit or delete teams.",
  },
  pay: {
    admin:
      'Full control of Vyce Pay, including HMRC settings and creating, editing and submitting timesheets.',
    manager: 'Can create, edit and submit timesheets.',
  },
  companies: {
    owner: 'Full access to everything, including the subscription.',
    admin: 'Full access to all Vyce modules. View every module dashboard and manage company admins.',
    manager:
      'Invite workers and add them to any team, location or pay schedule. Good for site managers.',
  },
};

/**
 * The line shown under a role in the role menu. A role without written copy (a new
 * one, or a module nobody has described yet) falls back to its permission list, so
 * the menu never goes blank.
 */
export const getRoleDescription = (moduleSystemName: string | undefined, role: CompanyRoleDTO) => {
  const described =
    ROLE_DESCRIPTIONS[(moduleSystemName || '').toLowerCase()]?.[role.role_name.trim().toLowerCase()];
  if (described) return described;
  // permission_names are display names, in a deliberate order.
  return role.permission_names?.length ? role.permission_names.join(' · ') : '';
};
